<template>
  <div :class="['owc-lower-footer', { 'owc-lower-footer--centered': centerElements }]">
    <SlotContainer v-if="isEdit" refName="slot-socialSection" slotName="socialSection">
      <slot slot="socialSection" name="socialSection" />
    </SlotContainer>
    <OwcFooterSocialSection
      v-else-if="socialSectionVisibility"
      :socialSection="socialSection"
    ></OwcFooterSocialSection>

    <SlotContainer v-if="isEdit" refName="slot-legalSection" slotName="legalSection">
      <slot slot="legalSection" name="legalSection" />
    </SlotContainer>
    <OwcFooterLegalSection v-else :legalSection="legalSection"></OwcFooterLegalSection>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import {
  LowerFooterSectionData,
  LowerFooterSectionMethods,
  LowerFooterSectionComputed,
  LowerFooterSectionProps,
} from './LowerFooter';
import { componentMode } from './Footer.config';
import OwcFooterSocialSection from '@owc-packages/Footer/src/SocialSection.vue';
import OwcFooterLegalSection from '@owc-packages/Footer/src/LegalSection.vue';
/**
 * `Lower Footer` - Lower Footer for OneWeb - Lower Footer contains the social and legal sections of the Footer, this component is able to display via slots the corresponding components.
 */

export default ComponentInitializeDispatcher.extend<
  LowerFooterSectionData,
  LowerFooterSectionMethods,
  LowerFooterSectionComputed,
  LowerFooterSectionProps
>({
  name: 'owc-lower-footer',
  components: {
    OwcFooterSocialSection,
    OwcFooterLegalSection,
    SlotContainer,
  },
  data() {
    return {
      centerElements: false,
    };
  },
  props: {
    socialSection: {
      type: Array,
    },
    legalSection: {
      type: Object,
    },
    socialSectionVisibility: {
      type: Boolean,
    },
  },
  computed: {
    isEdit: function(): boolean {
      return componentMode.isEditMode;
    },
  },
  mounted() {
    this.$el.addEventListener('qrCodeActive', () => this.centerLowerFooterContainer());
  },
  methods: {
    centerLowerFooterContainer: function() {
      this.centerElements = true;
    },
  },
});
</script>

<style lang="scss">
@import '@owc-styles/utils/rtl-utils';

$lowerFooterModuleName: 'owc-lower-footer';

.#{$lowerFooterModuleName} {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: var(--wb-spacing-s) 0;
  border-top: 1px solid var(--wb-grey-40);

  @include breakpoint-from(mq5) {
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  &--centered {
    align-items: center;
  }
  & > :first-child {
    width: 100%;

    @include breakpoint-from(mq5) {
      order: 1;
      width: auto;
      margin-bottom: 0;
    }
  }
  & > :last-child {
    width: 100%;

    @include breakpoint-from(mq5) {
      width: auto;
      margin-right: var(--wb-spacing-xs);
    }
  }

  // ## Author styles below
  // The min-width is needed because the parsys box from AEM need a default size so it can be clickable
  & > div {
    min-width: 150px;
  }
}

@include rtl-rule('.owc-lower-footer') {
  & > :last-child {
    @include breakpoint-from(mq5) {
      margin-right: 0;
      margin-left: var(--wb-spacing-xs);
    }
  }
}
</style>
